import Dashboard from '../container/peptide/Dashboard';

// Peptide child routes
const peptideRoutes = [
  {
    path: '',
    redirectTo: 'peptides-dashboard'
  },
  {
    path: 'peptides-dashboard',
    name: 'peptide-dashboard',
    component: Dashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  }
];

export default peptideRoutes;
